import React from "react";
import styled from "styled-components";

const InbioDescriptionContainer = styled("div")`
    position: relative;
    padding: 16px;
    margin-top: 24px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    // box-shadow: 5px 3px 30px black;

    &:before {
      content: "";
      margin: -35px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      filter: blur(10px);
      z-index: -1;
    }
  `;

  const InbioDescriptionTextContainer = styled("div")`
    width: 100%;
  `;

  const InbioDescriptionText = styled("div")`
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    word-break: break-word;
    text-align: center;
    line-height: 24px;
    color: #111111;
  `;

export default function InbioTextContent({ content }) {
  return (
    content.description && (
      <InbioDescriptionContainer>
        <InbioDescriptionTextContainer>
          <InbioDescriptionText>{content.description}</InbioDescriptionText>
        </InbioDescriptionTextContainer>
      </InbioDescriptionContainer>
    )
  );
}
